import AccountModel from 'common/core/models/Account'
import { AccountStatus } from 'common/core/models/Account/constants'

export const getAccountStatusLozenge = (accountStatus: AccountStatus) => {
  const isPro = AccountModel.isProOrTrialStatus(accountStatus)

  // Add Trial when implemented in the DS
  return isPro ? 'pro' : 'free'
}
